<span *ngIf="items.length > 0" class="case-service-materials" [pTooltip]="showTooltip ? tooltip : ''"
    tooltipPosition="top" tooltipEvent="hover">
    <i *ngFor="let relation of items" [ngClass]="iconOf(relation)"></i>
</span>
